<template>
    <div
        class="visualization expenses-visualization"
        v-loading="loading"
        element-loading-spinner="presupuesto-loader"
    >
        <h3>Ejecución de Gasto - {{ periodo }}</h3>
        <div class="row">
            <div class="col-sm-6">
                <el-radio-group v-model="periodo">
                    <el-radio-button
                        v-for="p in periodos"
                        :key="p"
                        :label="p"
                    ></el-radio-button>
                </el-radio-group>
            </div>
            <div class="col-sm-6 text-right">
                <div class="mode-selector" v-show="subtitulo === null">
                    <span class="title">Ver como</span>
                    <div class="view-buttons">
                        <el-tooltip content="Gráfico">
                            <a
                                href="#"
                                @click.prevent="mode = 'chart'"
                                :class="{ active: mode === 'chart' }"
                            >
                                <i class="material-icons">dashboard</i>
                            </a>
                        </el-tooltip>
                        <el-tooltip content="Tabla">
                            <a
                                href="#"
                                @click.prevent="mode = 'table'"
                                :class="{ active: mode === 'table' }"
                            >
                                <i class="material-icons">view_list</i>
                            </a>
                        </el-tooltip>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-show="mode === 'chart'">
            <div class="col-sm-3">
                <ol
                    v-show="mode === 'chart'"
                    class="breadcrumb breadcrumb-vertical"
                >
                    <li
                        class="breadcrumb-item"
                        v-for="(b, i) in breadcrumb"
                        :class="{ active: i === breadcrumb.length - 1 }"
                        @click.prevent="pop()"
                    >
                        <div class="title">{{ b.data.type }}</div>
                        <div>
                            <a v-if="i !== breadcrumb.length - 1" href="#">{{
                                b.data.name
                            }}</a>
                            <span v-else>{{ b.data.name }}</span>
                        </div>
                        <div class="amount">{{ moneyFormatter(b.value) }}</div>
                        <!--<div class="percentage">{{numeral(b.value / (b.parent ? b.parent.value : b.value)).format('0.00%')}}</div>-->
                    </li>
                </ol>
            </div>
            <div class="col-sm-9">
                <treemap-chart
                    v-show="subtitulo === null"
                    :width="825"
                    :height="510"
                    :data="hierarchicalData"
                    :breadcrumb.sync="breadcrumb"
                    ref="treemapChart"
                    @detail-clicked="detailClicked"
                ></treemap-chart>
                <expenses-detail-visualization
                    v-show="subtitulo !== null"
                    :height="510"
                    :where="detailWhere"
                    ref="detailViz"
                ></expenses-detail-visualization>
            </div>
        </div>
        <table-chart
            :height="510"
            :data="data"
            v-show="mode === 'table'"
        ></table-chart>

        <visualization-footer :url="this.url"></visualization-footer>
    </div>
</template>
<style lang="scss">
.explore-visualization {
    .breadcrumb {
        .breadcrumb-item {
            cursor: pointer;
            .item {
                display: inline-block;
                .title {
                    color: black;
                    font-size: 10px;
                    font-weight: 500;
                    text-transform: uppercase;
                }
            }
        }
    }
}
</style>
<script>
import axios from 'axios';
import _ from 'lodash';
import numeral from 'numeral';
import moneyFormatter from '../../Methods/MoneyFormatter';
import TreemapChart from '../Charts/Treemap';
import TableChart from '../Charts/Table';
import ExpensesDetailVisualization from './ExpensesDetail';
import VisualizationFooter from './Common/Footer';

export default {
    data: function() {
        return {
            loading: false,
            data: [],
            mode: 'chart',
            breadcrumb: [],
            subtitulo: null,
            periodos: [],
            periodo: this.$store.state.defaultYear
        };
    },
    props: ['institution'],
    components: {
        TreemapChart,
        TableChart,
        ExpensesDetailVisualization,
        VisualizationFooter
    },
    methods: {
        assign: _.assign,
        numeral: numeral,
        moneyFormatter: moneyFormatter,
        pop: function() {
            if (this.subtitulo === null) this.$refs.treemapChart.pop();
            else {
                this.subtitulo = null;
                this.breadcrumb.pop();
            }
        },
        detailClicked: function(n) {
            if (n.data.type === 'Subtitulo') this.subtitulo = n.data.id;

            this.breadcrumb.push(n);

            //this.$nextTick(()=>{
            //    this.$refs.detailViz.refreshData();
            //});
        },
        refreshData: function() {
            this.loading = true;
            axios.get(this.url).then(response => {
                this.loading = false;
                this.data = response.data;
                this.breadcrumb = [];
                this.subtitulo = null;
            });
        }
    },
    computed: {
        where: function() {
            let where = {
                periodo: this.periodo,
                partida: this.institution.partida
            };
            if (this.institution.capitulo)
                where.capitulo = this.institution.capitulo;
            if (this.institution.area) where.area = this.institution.area;

            return where;
        },
        detailWhere: function() {
            return _.assign(_.clone(this.where), { subtitulo: this.subtitulo });
        },
        url: function() {
            return (
                '/api/v1/data/pagos?group-by=' +
                JSON.stringify(['subtitulo']) +
                '&where=' +
                JSON.stringify(this.where)
            );
        },
        hierarchicalData: function() {
            return {
                id: 'root',
                type: 'Organismo',
                name: this.institution.nombre,
                children: _(this.data)
                    .groupBy('subtitulo')
                    .map(function(d) {
                        return {
                            id: d[0].subtitulo,
                            type: 'Subtitulo',
                            name: d[0].nombre_subtitulo,
                            size: d[0].sum
                        };
                    })
                    .value()
            };
        }
    },
    watch: {
        periodo: function(value) {
            this.$store.commit('setDefaultYear', value);
            this.refreshData();
        }
    },
    mounted: function() {
        this.refreshData();

        axios
            .get(
                '/api/v1/data/pagos?distinct=' +
                    JSON.stringify(['periodo']) +
                    '&order-by=' +
                    JSON.stringify(['periodo'])
            )
            .then(response => {
                this.periodos = response.data.map(d => {
                    return d.periodo;
                });
            });
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/Expenses.vue